import { CalendarList, ErrorState, LoadingState, useApi } from '@daghfal/core';
import { useQuery } from '@tanstack/react-query';

/**
 * The nursery's calendar for this child's family (FR-MSG-09, GAPS 5.3): the whole nursery's entries and those for the
 * child's class, so one class's trip is not read as everyone's.
 */
export function Calendar({ childId }: { childId: number }) {
  const api = useApi();
  const child = useQuery({ queryKey: ['child', childId], queryFn: () => api.children.get(childId) });

  if (child.isPending) return <LoadingState />;
  if (child.isError) return <ErrorState error={child.error} onRetry={() => void child.refetch()} />;

  return <CalendarList classId={child.data.classId} />;
}
